import { render, staticRenderFns } from "./banner-plugin.vue?vue&type=template&id=b022070c&scoped=true&lang=pug&"
import script from "./banner-plugin.vue?vue&type=script&lang=js&"
export * from "./banner-plugin.vue?vue&type=script&lang=js&"
import style0 from "./banner-plugin.vue?vue&type=style&index=0&id=b022070c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b022070c",
  null
  
)

export default component.exports